const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M319.945 416.26c-19.774 7.897-41.352 12.24-63.945 12.24-95.269 0-172.5-77.231-172.5-172.5 0-22.706 4.387-44.387 12.36-64.242M417.794 196.04c6.924 18.675 10.706 38.876 10.706 59.96 0 58.742-29.361 110.625-74.209 141.776M114.248 157.675C145.401 112.847 197.273 83.5 256 83.5c68.903 0 128.37 40.398 156.008 98.801",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 204.598,
    r: 30,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 321.311C406.289 300.489 385.336 286 361 286c-33.137 0-60 26.863-60 60 0 1.963.094 3.905.279 5.82",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 337.287,
    r: 22.287,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 157.598,
    r: 15,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.724 122.79C13.499 69.366-.342 28.981 14.319 14.319c20.366-20.366 90.368 14.266 176.006 82.134M415.43 321.526c67.945 85.705 102.629 155.776 82.251 176.154-29.289 29.289-161.237-55.171-294.714-188.648-61.258-61.257-112.192-122.193-146.544-173.031",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.769 354.284c45.633 55.433 70.535 96.163 61.607 105.091-14.873 14.873-117.984-64.124-230.306-176.445S37.751 67.498 52.625 52.625c8.929-8.929 49.657 15.972 105.087 61.603M196 121v15M226 121v15",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 46,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 181,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 10.462C462 32.298 479.702 50 501.538 50H512h-10.462C479.702 50 462 67.702 462 89.538V100 89.538C462 67.702 444.298 50 422.462 50H412h10.462C444.298 50 462 32.298 462 10.462V0v10.462z",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.958,
    cy: 450.958,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.614,
    cy: 346,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 422.462C50 444.298 67.702 462 89.538 462H100 89.538C67.702 462 50 479.702 50 501.538V512v-10.462C50 479.702 32.298 462 10.462 462H0h10.462C32.298 462 50 444.298 50 422.462V412v10.462z",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#fffdfd",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturn);
export default __webpack_public_path__ + "static/media/saturn.c67da60856fecab21aecec5cf53019e8.svg";
export { ForwardRef as ReactComponent };